/* A local platform hint only: no downloads, redirects, architecture guesses or network calls. */
(() => {
  if (window.MuteMeDownloads) { window.MuteMeDownloads.init(document); return; }
  function detectPlatform(browser) {
    try {
      const ua = String(browser.userAgent || '');
      const platform = String(browser.userAgentData?.platform || browser.platform || '');
      const mobile = browser.userAgentData?.mobile === true;
      // iPad desktop mode can identify as a Mac. Never recommend a desktop installer to it.
      if (/iPhone|iPad|iPod|Android/i.test(ua) || /Android|iOS/i.test(platform) || mobile || (/Mac/i.test(platform + ua) && Number(browser.maxTouchPoints) > 1)) return 'mobile';
      if (/CrOS|Chrome OS|ChromeOS/i.test(platform + ua)) return 'chromeos';
      if (/^Windows$|^Win/i.test(platform)) return 'windows';
      if (/^macOS$|^Mac/i.test(platform)) return 'macos';
      if (/^Linux/i.test(platform)) return 'linux';
      if (/Windows NT/i.test(ua)) return 'windows';
      if (/Macintosh|Mac OS X/i.test(ua)) return 'macos';
      if (/Linux/i.test(ua)) return 'linux';
    } catch (_) { /* Privacy tools can restrict navigator properties; keep every choice usable. */ }
    return 'unknown';
  }
  const messages = {
    windows: 'Your browser reports Windows. Choose your installer below.',
    macos: 'Your browser reports macOS. Choose Apple silicon or Intel below.',
    linux: 'Your browser reports Linux. Choose a package for your distribution.',
    mobile: 'Downloading for your computer? Choose its operating system below.',
    chromeos: 'There is no ChromeOS desktop installer. Choose another computer’s operating system below.',
    unknown: 'Choose the computer you’ll use with MuteMe.'
  };
  const names = { windows: 'Windows', macos: 'macOS', linux: 'Linux' };
  function init(scope) {
    const roots = [...scope.querySelectorAll('[data-mm-downloads]')];
    if (scope.matches?.('[data-mm-downloads]')) roots.unshift(scope);
    const platform = detectPlatform(window.navigator);
    roots.forEach(root => {
      root.dataset.mmDetectedPlatform = platform;
      const cards = [...root.querySelectorAll('[data-mm-platform]')];
      const match = cards.some(card => card.dataset.mmPlatform === platform);
      const status = root.querySelector('[data-mm-download-status]');
      if (status) status.textContent = names[platform] && !match ? messages.unknown : messages[platform];
      cards.forEach(card => {
        const recommended = !!names[platform] && card.dataset.mmPlatform === platform;
        card.dataset.mmRecommended = String(recommended);
        const badge = card.querySelector('[data-mm-platform-label]');
        if (badge) badge.textContent = recommended ? `Recommended for ${names[platform]}` : 'Desktop app';
      });
    });
  }
  window.MuteMeDownloads = { init, detectPlatform };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
